import { createSlice } from '@reduxjs/toolkit'

import { AgencySignOn } from 'apps/agency/agencyInterfaces'
import { parseAgency, parseAgencyConfig } from 'apps/agency/model/adapter'
import { AGENCY_FIELDS } from 'apps/agency/model/constants'
import { AGENCY } from 'apps/agency/model/defaults'
import { agencySignOnFieldsUpdated } from 'apps/agency/model/events'

import { fetch, updateProfile } from './thunks'

export const initialState = { ...AGENCY, config: null } as AgencySignOn

const signonSlice = createSlice({
  name: 'signon',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(agencySignOnFieldsUpdated, (state, action) => {
        return { ...state, ...action.payload }
      })
      .addCase(fetch.fulfilled, (state, action) => {
        const { agency, config, user } = action.payload

        return {
          ...state,
          ...(agency ? parseAgency(agency, user) || AGENCY : AGENCY),
          [AGENCY_FIELDS.config]: parseAgencyConfig(config),
        }
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        const { agency, user } = action.payload

        return {
          ...state,
          ...parseAgency(agency, user),
        }
      })
  },
})

export default signonSlice.reducer
